import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataSaqAep } from "../../data/4.0/formDataSaqAep";
import ComponentSaq from "../../components/ComponentSaq";

class SaqaEp extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  render() {
    return <ComponentSaq type="A-EP" formDataSaq={formDataSaqAep} />;
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SaqaEp);
